


import { useTheme } from "../../context/ThemeProvider";
import UIStore from "../../store/uiStore";
import SidebarToggler1 from "../Sidebar/SidebarToggler";
import React from "react";
import { ArrowLeft, SlidersHorizontal } from "lucide-react";
import { SunSvg, MoonSvg } from "../../assets";
import UserDropdown from "../Dropdowns/UserDropdown";
import NotificationBell from "../Notifications/NotificationBell";

// Icon shown beside the title on Settings pages (no page-specific icon supplied)
const SettingsIcon = () => (
  <div className="photon-settings-icon w-7 h-7 rounded-lg bg-fill-indigo-50 dark:bg-fill-hex-2d3557 flex items-center justify-center mr-2.5 flex-shrink-0">
    <SlidersHorizontal className="w-4 h-4 text-ink-primary dark:text-ink-accent" />
  </div>
);

const ModelsHeader = ({ title = "Model Garden", onBack, icon }) => {
  const { theme, toggleTheme } = useTheme();
  const showSidebar = UIStore((state) => state.showSidebar);
  const setShowSidebar = UIStore((state) => state.setShowSidebar);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <header className="sticky top-0 w-full flex-shrink-0 flex justify-between items-center px-[10px] xm:px-6 h-14 sm:h-16 z-50 border-b border-edge-border dark:border-edge-muted-control">
      {/* Left — sidebar toggler + back + icon + title */}
      <div className="flex items-center gap-1">
        {/* Sidebar toggler for <940px screens */}
        <div className="hidden max-[939px]:flex items-center">
          <SidebarToggler1
            className="pr-2 mr-0"
            showSidebar={showSidebar}
            toggleSidebar={toggleSidebar}
            theme={theme}
          />
        </div>
        {/* Back button (optional) */}
        {onBack && (
          <button
            onClick={onBack}
            className="mr-1 text-ink-primary dark:text-ink-accent hover:opacity-70 transition-opacity duration-200"
            title="Back"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        {/* Page icon */}
        {icon ?? <SettingsIcon />}
        {/* Title */}
        <span className="text-ink-ink dark:text-ink-white text-lg font-semibold">
          {title}
        </span>
      </div>

      {/* Right — notifications + appearance toggle + user dropdown */}
      <div className="flex items-center gap-2 sm:gap-3">
        <NotificationBell />
        <button
          type="button"
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Switch to Light" : "Switch to Dark"}
          title={theme === "dark" ? "Switch to Light" : "Switch to Dark"}
          className="bg-fill-gray-100 dark:bg-fill-gray-700 border border-edge-gray-200 dark:border-edge-panel-border shadow-sm px-1 w-11 h-6 rounded-full relative cursor-pointer flex justify-between items-center transition-colors duration-200 shrink-0"
        >
          <SunSvg className="photon-appearance-icon text-ink-primary dark:opacity-50 text-[14px]" />
          <MoonSvg className="photon-appearance-icon text-ink-gray-500 dark:text-ink-accent text-[14px]" />
          <span aria-hidden="true"
            className={`absolute w-4 h-4 rounded-full bg-fill-white dark:bg-fill-gray-200 shadow-md transition-transform duration-300 ease-in-out ${
              theme === "dark" ? "translate-x-[18px]" : "translate-x-0"
            }`}
          />
        </button>
        <UserDropdown />
      </div>
    </header>
  );
};

export default ModelsHeader;
